import { Component, EventEmitter, Output } from '@angular/core'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss'],
})
export class OverlayComponent {
  /** Emitted when the user clicks the backdrop (outside the overlay content). */
  @Output() overlayClick = new EventEmitter<void>()

  onBackdropClick(): void {
    this.overlayClick.emit()
  }
}
